import { Box, CardProps, Typography, useTheme } from "@mui/material";
import { PimoReactComponent } from "@pimo/pimo-app-builder";

import FeatureCard from "../../pimo-components/feature-card/feature-card";

export interface GenericStatusCardV2Props {
  /** Data of the substatuses */
  statuses: {
    status: string;
    name: string;
    count: number;
    imageUrl?: string;
  }[];
  /** Title */
  title: string;
  /** Column or Row style for the subcomponents */
  isRow?: boolean;
  /** Properties for styling */
  cardProps?: CardProps;
  cardIcon?: string;
}

export const GenericStatusCardV2: PimoReactComponent<
  GenericStatusCardV2Props
> = ({ cardProps = {}, statuses, title, cardIcon }) => {
  const theme = useTheme();

  return (
    <FeatureCard
      data-testid="StatusCard"
      {...cardProps}
      sx={{
        backgroundColor: theme.palette.primary.light,
        boxShadow: "none",
        borderRadius: "12px",
        p: 2,
        height: "100%",
        ...cardProps.sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",

          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        {cardIcon && (
          <Box
            component="img"
            src={cardIcon}
            sx={{
              backgroundColor: "white",
              borderRadius: "12px",
              p: "5px",
              mr: 2,
              height: "36px",
            }}
          />
        )}
        <Typography
          variant="h5"
          sx={{
            color: theme.palette.primary.contrastText,
            fontWeight: 500,
          }}
        >
          {title}
        </Typography>
      </Box>
      <Box sx={{ flex: "1 1 100%" }} />
      <Box
        sx={{
          pt: 1,
          display: "grid",
          gridTemplateRows: "repeat(3, 1fr)",
          gridGap: 0,
        }}
      >
        {statuses.map((status) => (
          <Box
            key={status.name}
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              color: theme.palette.primary.contrastText,
            }}
          >
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <StatusIndicator
                status={status.status}
                imageUrl={status.imageUrl}
              />
              <Typography
                variant="subtitle2"
                sx={{
                  paddingLeft: 2,
                  color: theme.palette.primary.contrastText,
                }}
              >
                {status.name}
              </Typography>
            </Box>
            <Typography variant="subtitle2">{status.count}</Typography>
          </Box>
        ))}
      </Box>
    </FeatureCard>
  );
};

const StatusIndicator: PimoReactComponent<{
  status: string;
  imageUrl?: string;
}> = ({ status, imageUrl }) => {
  return imageUrl ? (
    <Box
      component="img"
      src={imageUrl}
      alt="status indicator"
      data-testid="StatusIndicatorImage"
      sx={{
        width: 20,
        height: 20,
        borderRadius: "100%",
      }}
    />
  ) : (
    <Box
      data-testid="StatusIndicator"
      sx={{
        background: status,
        backgroundPosition: "center",
        width: 15,
        height: 15,
        borderRadius: "100%",
      }}
    />
  );
};

export default GenericStatusCardV2;
